import * as wjcCore from "@grapecity/wijmo"
import * as wjcGauge from "@grapecity/wijmo.gauge"
import * as wjrGauge from "@grapecity/wijmo.react.gauge"
import Decimal from "decimal.js"

import { useEffect, useRef, useState } from "react"
import { T部所売上額 } from "../../../service/dashboard/TDashboard"
import { create部所売上集計, T部所売上額集計値 } from "./BusyoUriagegaku"

export const BusyoUriagegakuGage: React.FC<{
  busyoUriageGakuList: T部所売上額[] | null | undefined
  busyoCode: string | undefined | null
}> = (props) => {
  const gaugeRef = useRef<wjrGauge.RadialGauge>(null)
  const [部所売上集計, set部所売上集計] = useState<T部所売上額集計値>()
  const [目標差額str, set目標差額str] = useState<string>()
  const [達成フラグ, set達成フラグ] = useState<boolean>()

  useEffect(() => {
    if (
      gaugeRef == null ||
      gaugeRef.current == null ||
      gaugeRef.current.control == null ||
      props.busyoUriageGakuList == null
    )
      return
    const data = create部所売上集計(props.busyoUriageGakuList, props.busyoCode)
    set部所売上集計(data)
    const 目標差額 = new Decimal(data.予算額).minus(data.当年実績).toNumber()

    set達成フラグ(目標差額 < 0)

    if (目標差額 > 0) {
      set目標差額str(wjcCore.Globalize.formatNumber(目標差額, "n0"))
    } else {
      set目標差額str(wjcCore.Globalize.formatNumber(目標差額 * -1, "n0"))
    }
    const gauge = gaugeRef.current.control as wjcGauge.RadialGauge
    gauge.max = 1.5
    gauge.value = data.達成率 != null ? data.達成率 : 0
  }, [props.busyoUriageGakuList, props.busyoCode])

  return (
    <div
      className="w-100"
      style={{
        border: "1px solid rgb(83, 154, 190)",
      }}>
      <div>売上目標値</div>
      <div className="m-auto w-75 px-5 pt-5 pb-3 dashboard-gauge">
        <wjrGauge.RadialGauge
          ref={gaugeRef}
          autoScale={true}
          isAnimated={true}
          showRanges={true}
          format={"p0"}
          thickness={0.1}
          showText={wjcGauge.ShowText.None}
          needleShape={wjcGauge.NeedleShape.Hexagon}>
          <wjrGauge.Range wjProperty="pointer" thickness={0.5}></wjrGauge.Range>
          <wjrGauge.Range
            min={0}
            max={0.5}
            color="rgba(242, 116, 117,0.6)"></wjrGauge.Range>
          <wjrGauge.Range
            min={0.5}
            max={1.0}
            color="rgba(255, 190, 96, 0.6)"></wjrGauge.Range>
          <wjrGauge.Range
            name={"目標達成"}
            min={1.0}
            max={1.5}
            color="rgba(100, 211, 115, 0.6)"></wjrGauge.Range>
        </wjrGauge.RadialGauge>
      </div>
      {部所売上集計 && !達成フラグ ? (
        <div className="w-100 text-center">残り:{`\\${目標差額str}`}</div>
      ) : (
        <div className="w-100 text-center fw-bold text-primary">
          {達成フラグ != null && `予算達成:\\${目標差額str}`}
        </div>
      )}
    </div>
  )
}
